import { createStyles, makeStyles } from '@material-ui/core/styles';

export default makeStyles(() =>
  createStyles({
    noPaddingBot: {
      paddingBottom: '0 !important',
    },
    noPaddingTop: {
      paddingTop: '0 !important',
    },
    qtdWrapperStyle: {
      paddingTop: '3px !important',
    },
    morePaddingTop: {
      paddingTop: 10,
    },
    noVerticalPadding: {
      paddingBottom: '0 !important',
      paddingTop: '0 !important',
    },
  }),
);
